import { Component, OnInit, Input, HostListener, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MapsService } from 'app/modules/maps';
import { RouteDetailViewModel } from 'app/modules/route-detail/viewModels/route-detail-viewmodel';
import * as moment from 'moment';
import * as jsPDF from 'jspdf';
import * as _html2canvas from 'html2canvas';
import { BranchingApiService } from '../../services/branching.api.service';
import BranchConstants from 'app/modules/shared/constants/branch-constant';
import { HelperMethods } from '../../Helpers/herlperMethods';
const html2canvas: any = _html2canvas;
@Component({
  selector: 'app-branch-filters',
  templateUrl: './branch-filters.component.html',
  styleUrls: ['./branch-filters.component.scss']
})
export class BranchFiltersComponent implements OnInit {
  public selectedFromDate;
  public selectedToDate;
  private isMondayClicked: Boolean = true;
  private isTuisdayClicked: Boolean = true;
  private isWensdayClicked: Boolean = true;
  private isThursdayClicked: Boolean = true;
  private isFridayClicked: Boolean = true;
  private isSaterdayClicked: Boolean = true;
  private isSundayClicked: Boolean = true;
  public days: string[] = BranchConstants.days;
  public daysList: string[] = [];
  public MO = '1';
  public TU = '2';
  public WE = '3';
  public THU = '4';
  public FR = '5';
  public SAT = '6';
  public SUN = '0';
  private timesWithInterval: any[] = [];
  public allTime: any[] = [];
  public periods: string[] = BranchConstants.periods;
  public selectedFromPeriod: string;
  public hour: number;
  public minute: number;
  dates: Date[] = [];
  @Input() currentRoute: RouteDetailViewModel;
  @Input() routeDetailList: RouteDetailViewModel[];
  @Input() parentDivHeight: any;
  branchingData;
  public selectedDay;
  @Output() periodeChange: EventEmitter<any> = new EventEmitter();
  @Output() mo: EventEmitter<any> = new EventEmitter();
  @Output() tu: EventEmitter<any> = new EventEmitter();
  @Output() we: EventEmitter<any> = new EventEmitter();
  @Output() thu: EventEmitter<any> = new EventEmitter();
  @Output() fr: EventEmitter<any> = new EventEmitter();
  @Output() sat: EventEmitter<any> = new EventEmitter();
  @Output() sun: EventEmitter<any> = new EventEmitter();
  @Output() startDateChange: EventEmitter<any> = new EventEmitter();
  @Output() endDateChange: EventEmitter<any> = new EventEmitter();
  constructor(private mapsService: MapsService, private sr: BranchingApiService) { }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerHeight < 800) {
      document.getElementById('charts').style.height = '40%';
    } else {
      document.getElementById('charts').style.height = '60%';
    }
  }
  ngOnInit() {
    this.initialData();
  }
  OnChanges(changes: SimpleChanges): void {
    if (changes['currentRoute'] !== undefined && !changes['currentRoute'].firstChange) {
      this.initialData();
    }
  }
  private initialData() {
    this.dates = HelperMethods.getDateList(this.currentRoute.startDate, this.currentRoute.endDate, this.currentRoute.days);
    this.selectExistingDays(this.dates);
    this.selectedFromDate = this.dates[0];
    this.selectedToDate = this.dates[this.dates.length - 1];
    this.selectedFromPeriod = this.periods[0];
    let stringstartTime = this.currentRoute.startTime;
    let hour = moment(stringstartTime, 'HH:mm:ss').hour();
    this.minute = moment(stringstartTime, 'HH:mm:ss').minute();
    this.calcTime(hour);
    HelperMethods.createArrayPassedOnTime(this.hour, this.minute.toString(), 24, this.routeDetailList);
    HelperMethods.createArrayPassedOnTimePerHoure(0, 23);
    this.mapsService.clearRoute();
  }

  selectExistingDays(dates) {
    let daysSelected = [];
    dates.forEach(d => {
      daysSelected.push(d.getDay());
    });
    if (daysSelected.includes(1)) {
      this.isMondayClicked = true;
    } else {
      this.isMondayClicked = false;
    }
    if (daysSelected.includes(2)) {
      this.isTuisdayClicked = true;
    } else {
      this.isTuisdayClicked = false;
    }
    if (daysSelected.includes(3)) {
      this.isWensdayClicked = true;
    } else {
      this.isWensdayClicked = false;
    }
    if (daysSelected.includes(4)) {
      this.isThursdayClicked = true;
    } else {
      this.isThursdayClicked = false;
    }
    if (daysSelected.includes(5)) {
      this.isFridayClicked = true;
    } else {
      this.isFridayClicked = false;
    }
    if (daysSelected.includes(6)) {
      this.isSaterdayClicked = true;
    } else {
      this.isSaterdayClicked = false;
    } if (daysSelected.includes(0)) {
      this.isSundayClicked = true;
    } else {
      this.isSundayClicked = false;
    }

  }
  calcTime(hour) {
    if (this.minute < 10) {
      let minute = parseFloat('0.0' + this.minute);
      this.hour = hour + minute;
    } else {
      let minute = parseFloat('0.' + this.minute);
      this.hour = hour + minute;
    }
    return this.hour;
  }
  startDateChanged(date) {
    this.startDateChange.emit(date);
  }
  endDateChanged(date) {
    this.endDateChange.emit(date);
  }
  MondayClicked() {
    this.isMondayClicked = !this.isMondayClicked;
    if (!this.isMondayClicked) {
      HelperMethods.removeElementFromStringArray('MO', this.days);
      this.MO = 'x';
    } else {
      this.MO = '1';
      this.days.push('MO');

    }
    this.mo.emit(this.MO);
  }
  TuisdayClicked() {
    this.isTuisdayClicked = !this.isTuisdayClicked;
    if (!this.isTuisdayClicked) {
      HelperMethods.removeElementFromStringArray('TU', this.days);
      this.TU = 'x';
    } else {
      this.TU = '2';
      this.days.push('TU');

    }
    this.tu.emit(this.TU);
  }
  WensdayClicked() {
    this.isWensdayClicked = !this.isWensdayClicked;
    if (!this.isWensdayClicked) {
      this.WE = 'x';
      HelperMethods.removeElementFromStringArray('WE', this.days);
    } else {
      this.WE = '3';
      this.days.push('WE');

    }
    this.we.emit(this.WE);
  }
  ThursdayClicked() {
    this.isThursdayClicked = !this.isThursdayClicked;
    if (!this.isThursdayClicked) {
      HelperMethods.removeElementFromStringArray('THU', this.days);
      this.THU = 'x';
    } else {
      this.THU = '4';
      this.days.push('THU');

    }
    this.thu.emit(this.THU);
  }
  FridayClicked() {
    this.isFridayClicked = !this.isFridayClicked;
    if (!this.isFridayClicked) {
      HelperMethods.removeElementFromStringArray('FR', this.days);
      this.FR = 'x';
    } else {
      this.FR = '5';
      this.days.push('FR');

    }
    this.fr.emit(this.FR);
  }
  SaterdayClicked() {
    this.isSaterdayClicked = !this.isSaterdayClicked;
    if (!this.isSaterdayClicked) {
      HelperMethods.removeElementFromStringArray('SAT', this.days);
      this.SAT = 'x';
    } else {
      this.SAT = '6';
      this.days.push('SAT');

    }
    this.sat.emit(this.SAT);
  }
  SundayClicked() {
    this.isSundayClicked = !this.isSundayClicked;
    if (!this.isSundayClicked) {
      HelperMethods.removeElementFromStringArray('SUN', this.days);
      this.SUN = 'x';
    } else {
      this.SUN = '0';
      this.days.push('SUN');

    }
    this.sun.emit(this.SUN);
  }
  periodChanged(e) {
    let selectedValue = e.value;
    let hour;
    switch (selectedValue) {
      case 'ALL(0-24)':
        hour = this.calcTime(0);
        this.timesWithInterval = HelperMethods.createArrayPassedOnTime(hour, this.minute.toString(), 24, this.routeDetailList);
        this.allTime = HelperMethods.createArrayPassedOnTimePerHoure(0, 23);
        break;
      case 'PEAK MORNING(6-9)':
        hour = this.calcTime(6);
        this.timesWithInterval = HelperMethods.createArrayPassedOnTime(hour, this.minute.toString(), 9, this.routeDetailList);
        this.allTime = HelperMethods.createArrayPassedOnTimePerHoure(6, 8);
        break;
      case 'PEAK EVENING(16-19)':
        hour = this.calcTime(16);
        this.timesWithInterval = HelperMethods.createArrayPassedOnTime(hour, this.minute.toString(), 19, this.routeDetailList);
        this.allTime = HelperMethods.createArrayPassedOnTimePerHoure(16, 18);
        break;
      case 'LOW':
        let Interval1 = [];
        let Interval2 = [];
        let Interval3 = [];
        this.timesWithInterval = [];
        let time1 = [];
        let time2 = [];
        let time3 = [];
        this.allTime = [];
        Interval1 = HelperMethods.createArrayPassedOnTime(this.calcTime(0), this.minute.toString(), 5, this.routeDetailList);
        Interval2 = HelperMethods.createArrayPassedOnTime(this.calcTime(9), this.minute.toString(), 15, this.routeDetailList);
        Interval3 = HelperMethods.createArrayPassedOnTime(this.calcTime(19), this.minute.toString(), 23, this.routeDetailList);
        this.timesWithInterval = Interval1.concat(Interval2, Interval3);
        time1 = HelperMethods.createArrayPassedOnTimePerHoure(0, 5);
        time2 = HelperMethods.createArrayPassedOnTimePerHoure(9, 15);
        time3 = HelperMethods.createArrayPassedOnTimePerHoure(19, 23);
        this.allTime = time1.concat(time2, time3);
        break;
      default:
        hour = this.calcTime(0);
        this.timesWithInterval = HelperMethods.createArrayPassedOnTime(hour, this.minute.toString(), 24, this.routeDetailList);
        this.allTime = HelperMethods.createArrayPassedOnTimePerHoure(0, 23);
        break;
    }
    this.periodeChange.emit({ allTime: this.allTime, timesWithInterval: this.timesWithInterval });
  }
  getDayName(date: Date): string {
    return moment(date).format('dddd').toUpperCase();
  }
  async downloadPdf() {
    let imgs = Array.from(document.getElementsByClassName('img'));
    let map = document.getElementById('imgMaps');
    let counter = 0;
    let currentPosition = document.getElementById('charts').scrollTop;
    let h = document.getElementById('charts').offsetHeight;
    // tslint:disable-next-line:no-unused-expression
    this.parentDivHeight;
    document.getElementById('charts').style.height = 'auto';
    let doc = new jsPDF('p', 'mm', 'a4');
    const data = Date.now();
    const year = (new Date()).getFullYear();
    doc.setFont('Exo 2');
    doc.setFontType('bold');
    doc.setFontSize(20);
    doc.text(80, 15, 'Analyse rapport');


    doc.setFont('Exo 2');
    doc.setFontType('bold');
    doc.setFontSize(10);
    doc.text(5, 30, 'Route Name :');
    doc.text(5, 35, 'Start address :');
    doc.text(5, 40, 'End address :');
    doc.text(5, 45, 'From-To date :');
    doc.text(5, 50, 'From-To time :');
    doc.text(5, 55, 'Request inerval :');
    doc.text(5, 60, 'Days :');
    doc.text(5, 65, 'Hours :');

    doc.setFontType('Exo 2');
    doc.setFontSize(10);
    doc.text(50, 30, this.currentRoute.name);
    doc.text(50, 35, this.currentRoute.startAddress);
    doc.text(50, 40, this.currentRoute.endAddress);
    doc.text(50, 45, HelperMethods.formatDate(this.currentRoute.startDate) + ' - ' + HelperMethods.formatDate(this.currentRoute.endDate));
    doc.text(50, 50, this.currentRoute.startTime + ' - ' + this.currentRoute.endTime);
    doc.text(50, 55, 'Every ' + this.currentRoute.interval + ' minutes');
    let margin = 50;
    this.days.forEach(element => {
      switch (element) {
        case 'MO':
          doc.text(margin, 60, 'MO,');
          margin += 6;
          break;
        case 'TU':
          doc.text(margin, 60, 'TU,');
          margin += 6;
          break;
        case 'WE':
          doc.text(margin, 60, 'WE,');
          margin += 6;
          break;
        case 'THU':
          doc.text(margin, 60, 'THU,');
          margin += 8;
          break;
        case 'FR':
          doc.text(margin, 60, 'FR,');
          margin += 6;
          break;
        case 'SAT':
          doc.text(margin, 60, 'SAT,');
          margin += 7;
          break;
        case 'SUN':
          doc.text(margin, 60, 'SUN');
          margin += 7;
          break;
      }
    });
    doc.text(50, 65, this.selectedFromPeriod);
    let img2 = '';
    let logoHeader = '<img src=\'../../../../../../src/assets/logo-odiq.png\' alt=\'logo\' width=\'50\' height=\'15\'>';
    let copy = '<p> &#169; ' + year + ' ODIQ - a Geo Mobility product</p>';
    doc.fromHTML(logoHeader, 5, 5);
    html2canvas(map, {
      useCORS: true
    }).then(canvas => {
      img2 = canvas.toDataURL('image/png', 0.9);
    });
    await this.delay(4000);
    imgs.forEach((c: HTMLElement, i) => {
      html2canvas(c, {
        logging: true, useCORS: true, allowTaint: true,
      })
        .then(res => {
          if (img2 !== '') {
            const img = res.toDataURL('image/png', 0.9);
            let imgHeight = res.height * 150 / res.width;
            let graphsHeight = res.height * 100 / res.width;
            if (i === 0) {
              doc.setFont('times');
              doc.setFontType('normal');
              doc.setFontSize(15);
              doc.text(5, 75, 'Route information');
              doc.text(5, 165, 'Route view');
              doc.addImage(img2, 'png', 20, 170, 100, 100);
              doc.addImage(img, 'png', 20, 75, 135, graphsHeight);
              counter++;
            } else if (i === 1) {
              doc.setFont('times');
              doc.setFontType('normal');
              doc.setFontSize(15);
              doc.text(5, 20, 'Route summary');
              doc.addImage(img, 'png', 20, 25, 150, imgHeight);
              counter++;
            } else if (i === 2) {
              doc.setFont('times');
              doc.setFontType('normal');
              doc.setFontSize(15);
              doc.text(5, 125, 'Overview per hour');
              doc.addImage(img, 'png', 20, 130, 150, imgHeight);
              doc.fromHTML(copy, 65, 276);
              counter++;
            } else if (i === 3) {
              counter++;
            }
            if (counter === 0 || counter === 1) {

              doc.addPage();
            }
          }
        })
        .then(() => {
          if (counter === imgs.length) {
            doc.save(this.currentRoute.name + '|' + HelperMethods.formatDate(data) + '.pdf');
          }
        });
    });
    let HeightPercentage = Math.ceil((h / this.parentDivHeight) * 100) + '%';
    document.getElementById('charts').style.height = HeightPercentage;
    document.getElementById('charts').scrollTop = currentPosition;
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/components/branching-container/components/branch-filter/branch-filters.component.ts